import {
  AnalyticsCategory,
  AnalyticsName,
} from "@storebrand-digital/insurance-analytics";

import { AddProduct } from "Store/addProductToCart/interfaces";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { BrandModelAndYear } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/BaseVehicleProduct";
import { Partner } from "Store/partners/partnerInterfaces";

/* eslint-disable sonarjs/max-switch-cases */
export function googleAnalyticsCategoryOf(
  name: INSURANCE_NAME_VALUE,
): AnalyticsCategory | undefined {
  switch (name) {
    case INSURANCE_NAME_VALUE.ANIMAL:
    case INSURANCE_NAME_VALUE.AKA_HOUSE_CONTENTS:
    case INSURANCE_NAME_VALUE.AKA_STUDENT:
    case INSURANCE_NAME_VALUE.AKA_TRAVEL:
    case INSURANCE_NAME_VALUE.BOAT:
    case INSURANCE_NAME_VALUE.CABIN:
    case INSURANCE_NAME_VALUE.CABIN_CONTENTS:
    case INSURANCE_NAME_VALUE.CAR:
    case INSURANCE_NAME_VALUE.CAR_NORSK_ELBILFORENING:
    case INSURANCE_NAME_VALUE.CARAVAN:
    case INSURANCE_NAME_VALUE.ELECTRIC_SCOOTER:
    case INSURANCE_NAME_VALUE.HOUSE:
    case INSURANCE_NAME_VALUE.HOUSE_CONTENTS:
    case INSURANCE_NAME_VALUE.HUSEIERNE_HOUSE_CONTENTS:
    case INSURANCE_NAME_VALUE.MOPED:
    case INSURANCE_NAME_VALUE.MOTORCYCLE:
    case INSURANCE_NAME_VALUE.TRACTOR:
    case INSURANCE_NAME_VALUE.TRAILER:
    case INSURANCE_NAME_VALUE.TRAVEL:
    case INSURANCE_NAME_VALUE.VALUABLES:
    case INSURANCE_NAME_VALUE.VETERAN_AUTO:
      return "Skadeforsikring";
    case INSURANCE_NAME_VALUE.ACCIDENT:
    case INSURANCE_NAME_VALUE.AKA_CHILD:
    case INSURANCE_NAME_VALUE.AKA_CRITICAL_ILLNESS:
    case INSURANCE_NAME_VALUE.AKA_GROUP_LIFE:
    case INSURANCE_NAME_VALUE.AKA_FAMILY_ACCIDENT:
    case INSURANCE_NAME_VALUE.CHILD:
    case INSURANCE_NAME_VALUE.CHILD_HEALTH:
    case INSURANCE_NAME_VALUE.CRITICAL_ILLNESS:
    case INSURANCE_NAME_VALUE.DEATH:
    case INSURANCE_NAME_VALUE.DISABILITY_FLEX:
    case INSURANCE_NAME_VALUE.NEW_CHILD:
    case INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN:
    case INSURANCE_NAME_VALUE.SOP_SICKNESS_LEAVE:
    case INSURANCE_NAME_VALUE.AKA_HEALTH:
    case INSURANCE_NAME_VALUE.HEALTH:
      return "Liv og helse";
    default:
      return undefined;
  }
}

export function googleAnalyticsNameOf(
  name: INSURANCE_NAME_VALUE,
): AnalyticsName {
  switch (name) {
    case INSURANCE_NAME_VALUE.ACCIDENT:
      return "ulykke";
    case INSURANCE_NAME_VALUE.ANIMAL:
      return "hund og katt";
    case INSURANCE_NAME_VALUE.AKA_CHILD:
      return "a+ barneforsikring";
    case INSURANCE_NAME_VALUE.AKA_CRITICAL_ILLNESS:
      return "a+ kritisk sykdom";
    case INSURANCE_NAME_VALUE.AKA_GROUP_LIFE:
      return "a+ gruppeliv";
    case INSURANCE_NAME_VALUE.AKA_FAMILY_ACCIDENT:
      return "a+ familieulykke";
    case INSURANCE_NAME_VALUE.AKA_HEALTH:
      return "a+ helseforsikring";
    case INSURANCE_NAME_VALUE.AKA_HOUSE_CONTENTS:
      return "a+ innbo";
    case INSURANCE_NAME_VALUE.AKA_STUDENT:
      return "a+ student";
    case INSURANCE_NAME_VALUE.AKA_TRAVEL:
      return "a+ reise";
    case INSURANCE_NAME_VALUE.BOAT:
      return "båt";
    case INSURANCE_NAME_VALUE.CABIN:
      return "hytte";
    case INSURANCE_NAME_VALUE.CABIN_CONTENTS:
      return "innbo i hytte";
    case INSURANCE_NAME_VALUE.CHILD:
      return "barneforsikring";
    case INSURANCE_NAME_VALUE.CHILD_HEALTH:
      return "helseforsikring for barn";
    case INSURANCE_NAME_VALUE.CRITICAL_ILLNESS:
      return "kritisk sykdom";
    case INSURANCE_NAME_VALUE.DEATH:
      return "dødsfallsforsikring";
    case INSURANCE_NAME_VALUE.DISABILITY_FLEX:
      return "uføreforsikring";
    case INSURANCE_NAME_VALUE.ELECTRIC_SCOOTER:
      return "elsparkesykkelforsikring";
    case INSURANCE_NAME_VALUE.CAR:
      return "bil";
    case INSURANCE_NAME_VALUE.CAR_NORSK_ELBILFORENING:
      return "elbilforsikring";
    case INSURANCE_NAME_VALUE.CARAVAN:
      return "campingvogn";
    case INSURANCE_NAME_VALUE.HEALTH:
      return "helseforsikring";
    case INSURANCE_NAME_VALUE.HOUSE:
      return "hus";
    case INSURANCE_NAME_VALUE.HOUSE_CONTENTS:
      return "innbo i hjem";
    case INSURANCE_NAME_VALUE.HUSEIERNE_HOUSE_CONTENTS:
      return "innbo huseierne";
    case INSURANCE_NAME_VALUE.MOPED:
      return "moped";
    case INSURANCE_NAME_VALUE.MOTORCYCLE:
      return "motorsykkel";
    case INSURANCE_NAME_VALUE.NEW_CHILD:
      return "barneforsikring";
    case INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN:
      return "gravid- og spedbarnsforsikring";
    case INSURANCE_NAME_VALUE.SOP_SICKNESS_LEAVE:
      return "sykeavbrudd";
    case INSURANCE_NAME_VALUE.TRACTOR:
      return "traktor privat";
    case INSURANCE_NAME_VALUE.TRAILER:
      return "tilhenger";
    case INSURANCE_NAME_VALUE.TRAVEL:
      return "reise";
    case INSURANCE_NAME_VALUE.VALUABLES:
      return "verdisak";
    case INSURANCE_NAME_VALUE.VETERAN_AUTO:
      return "veterankjøretøy";
    default:
      return "ukjent";
  }
}

export const partnerNameFromPartnerId = (partnerId: "" | Partner): string => {
  switch (partnerId) {
    case Partner.AFAG:
    case Partner.LEGEFORENINGEN:
    case Partner.TANNLEGEFORENINGEN:
    case Partner.VETERINARENE:
    case Partner.ECONA:
    case Partner.NATURVITERNE:
    case Partner.LEKTORLAGET:
    case Partner.PSYKOLOGFORENINGEN:
    case Partner.SAMFUNNSOKONOMENE:
    case Partner.SAMFUNNSVITERNE:
    case Partner.COOP:
    case Partner.DANSKE_BANK:
    case Partner.HUSEIERNE:
      return partnerId;
    default:
      return "storebrand";
  }
};

export const formatTrackId = (text: string): string =>
  text
    .trim()
    .replace(/[\s_]/g, "-")
    .replace(/[()\.:']/g, "")
    .toLowerCase();

export function formatItemInformation(
  productInfo: InsuranceProduct | AddProduct | BrandModelAndYear,
): string | undefined {
  if (
    "brand" in productInfo &&
    "model" in productInfo &&
    "modelYear" in productInfo
  ) {
    return `${productInfo.brand} ${productInfo.model} ${productInfo.modelYear}`;
  }
  return undefined;
}

export const mapToBrandModelAndYear = (
  formStates: Record<string, any>,
): BrandModelAndYear | undefined => {
  const brandModelAndYears = Object.values(formStates)
    .filter(
      (state) =>
        !!state.brand && !!state.model && (!!state.modelYear || !!state.year),
    )
    .map(({ brand, model, year, modelYear }) => ({
      brand,
      model,
      modelYear: modelYear || year,
    }));

  if (brandModelAndYears.length > 0) {
    return brandModelAndYears[0];
  }

  return undefined;
};
